export default "__VITE_ASSET__B7LxB1CQ__"